import * as cx from 'classnames';
import * as React from 'react';
import { ChangeEvent } from 'react';
import * as Styles from './IntlTelephoneSelect.scss';

type CountryItem = {
  code: string;
  name: string;
  dial_code?: string;
};

interface IOwnProps {
  countriesList: CountryItem[];
  handleSelectChange: (event: ChangeEvent<any>) => void;
  countryCode: string;
}

const IntlTelephoneSelect = (props: IOwnProps) => {
  const { countriesList, handleSelectChange, countryCode } = props;
  // @ts-ignore
  const countryIconClassNames = cx({
    [Styles.icon]: true,
    [Styles[countryCode || 'ZZ']]: true,
  });

  return(
    <div className={Styles.wrapper}>
      <div className={`${Styles.iconWrapper} flag-icon flag-icon-${countryCode}`}>
        <div className={countryIconClassNames} />
      </div>
      <select className={Styles.select} onChange={handleSelectChange} value={countryCode}>
        {countriesList.map((countryItem: CountryItem) => {
          return (
            <option value={countryItem.code} key={countryItem.code}>
              {countryItem.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default IntlTelephoneSelect;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/IntlTelephoneSelect/IntlTelephoneSelect.tsx